import { render, staticRenderFns } from "./audience.vue?vue&type=template&id=34e14aa2&"
import script from "./audience.vue?vue&type=script&lang=js&"
export * from "./audience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports